export { unstable_generateUtilityClass as default } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/generateUtilityClass/index.js
// module id = 979
// module chunks = 25